import { useSelector } from 'react-redux';
import { selectUserRoles } from '../store/slices/authSlice';
import { ROLE_PERMISSIONS } from '../config/roles';

export const useRolePermissions = () => {
  const userRoles = useSelector(selectUserRoles);

  const hasPermission = (feature) => {
    return userRoles.some(role => {
      const perms = ROLE_PERMISSIONS[role]?.features;
      return Array.isArray(perms) && perms.includes(feature);
    });
  };

  const hasAnyRole = (roles) => {
    return roles.some(role => userRoles.includes(role));
  };

  const hasAllRoles = (roles) => {
    return roles.every(role => userRoles.includes(role));
  };

  return {
    hasPermission,
    hasAnyRole,
    hasAllRoles,
    userRoles
  };
}; 